import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'rx-ie-detection',
  templateUrl: './rx-ie-detection.component.html',
  styleUrls: ['./rx-ie-detection.component.scss'],
})
export class RxIEDetectionComponent implements OnInit, OnDestroy {
  constructor() {}

  public ngOnInit() {}

  public ngOnDestroy() {}
}
